// Single source of truth for selectable Claude models in the dashboard.
// Verified against Anthropic's current model lineup (Opus 5 GA).
// The runner is the Claude Agent SDK, so only Anthropic models are supported.
export interface ModelOption {
  value: string;
  label: string;
}

export const MODELS: ModelOption[] = [
  { value: 'claude-opus-5', label: 'Claude Opus 5' },
  { value: 'claude-sonnet-5', label: 'Claude Sonnet 5' },
  { value: 'claude-haiku-4-5', label: 'Claude Haiku 4.5' },
  { value: 'claude-fable-5', label: 'Claude Fable 5' },
  { value: 'claude-opus-4-8', label: 'Claude Opus 4.8 (legacy)' },
];

// Anthropic recommends Opus 5 for agentic coding / enterprise work.
export const DEFAULT_MODEL = 'claude-opus-5';
